import { useRootAppStore } from "@hooks";
import { getCurrentCulture } from "@utils";
import React from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { THEME_SETTINGS } from "@theme-settings";

export default function CreditRatingCheckInfo() {
	const rootStore = useRootAppStore();

	const { t } = useTranslation("credit-rating");

	if (!THEME_SETTINGS.isCreditRatingCheckEnabled) {
		return null;
	}

	if (
		!rootStore.userAuthStore.user?.isInternetUser &&
		!rootStore.userAuthStore.secondaryUser?.isCreditRatingCheckRequired
	) {
		return null;
	}

	if (
		rootStore.userAuthStore.user?.isInternetUser &&
		!rootStore.userAuthStore.user?.isCreditRatingCheckRequired
	) {
		return null;
	}

	return (
		<div className="popup__col col col-sml-12">
			<div className="message message--base">
				<div className="message__content u-padd--reset">
					<div className="message__title u-type--xmed">
						<i className="message__icon u-icon u-icon--lrg u-icon--credit-rating-check u-color--sent--warning u-mar--right--tny" />
						<span className="u-align--v--middle">{t("TITLE")}</span>
					</div>

					<ReactMarkdown className="message__text">
						{t("DESCRIPTION")}
					</ReactMarkdown>

					<Link
						className="at-welcomeModalBtnVerif u-anchor u-anchor--warning u-anchor--underline has-arrow"
						to={`/${getCurrentCulture()}/account-settings/credit-rating`}
						onClick={() => {
							rootStore.welcomeStore.hidePopup(),
								rootStore.requiredUserActionStore.hidePopup();
						}}
					>
						{t("TITLE")}
					</Link>
				</div>
			</div>
		</div>
	);
}
